module.exports = __webpack_public_path__ + "area_shanghai_dark.c9179699.png";